import type { Params } from './types';
import { TIPOS_PUBLICACION } from './simular';
import { NumInput } from './ui';

// ─── Parámetros panel ─────────────────────────────────────────────────────
export function ParamsPanel({ p, setP }: { p: Params; setP: (p: Params) => void }) {
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5">
      <h2 className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-4 flex items-center gap-2">
        <svg className="w-4 h-4 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        Parámetros del cálculo
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 items-end">
        <NumInput label="Rentabilidad deseada" value={p.rentabilidadPct} onChange={v => setP({ ...p, rentabilidadPct: v })} prefix="" suffix="% del costo" step={1} min={0}
          hint="Si te costó $100 y ponés 20%, te quedan $20 limpios." />
        <NumInput label="IVA proveedor" value={p.ivaAlicuota} onChange={v => setP({ ...p, ivaAlicuota: v })} prefix="" suffix="%" step={0.5} min={0} />

        {/* Tipo publicación */}
        <div className="flex flex-col gap-1">
          <span className="text-xs font-medium text-slate-500 uppercase tracking-wide">Publicación</span>
          <div className="flex gap-1">
            {TIPOS_PUBLICACION.map(t => (
              <button key={t.id} onClick={() => setP({ ...p, tipo: t.id })}
                className={`flex-1 px-2 py-2 rounded text-xs font-medium border transition-all ${
                  p.tipo === t.id ? 'bg-brand-500 border-brand-500 text-white' : 'border-slate-200 text-slate-600 hover:border-brand-300'
                }`}>
                {t.label}
              </button>
            ))}
          </div>
        </div>

        {/* Costo con/sin IVA */}
        <div className="flex flex-col gap-1">
          <span className="text-xs font-medium text-slate-500 uppercase tracking-wide">Costo en catálogo</span>
          <div className="flex gap-1">
            {[{ label: 'Con IVA', v: true }, { label: 'Sin IVA', v: false }].map(({ label, v }) => (
              <button key={String(v)} onClick={() => setP({ ...p, costoConIva: v })}
                className={`flex-1 px-2 py-2 rounded text-xs font-medium border transition-all ${
                  p.costoConIva === v ? 'bg-slate-700 border-slate-700 text-white' : 'border-slate-200 text-slate-600 hover:border-slate-400'
                }`}>{label}</button>
            ))}
          </div>
        </div>
      </div>
      <p className="mt-3 text-[11px] text-slate-400">
        Misma cuenta que «Por publicación». La comisión de cada tipo, el costo fijo, los IIBB, el redondeo y el envío por peso salen de la solapa Parámetros.
      </p>
    </div>
  );
}
